import { JwtProvider } from "../../contexts/jwtContext";
import { UserProvider } from "../../contexts/userContext";
import { TabIndexProvider } from "../../contexts/tabIndexContext";
import { UpdateMessageProvider } from "../../contexts/updateMessageContext";
import { UpdateTimeSlotProvider } from "../../contexts/updateTimeSlotContext";
import { UpdateAnnouncementProvider } from "../../contexts/updateAnnouncementContext";

// provider for all contexts in App
const ContextProvider = ({ children }) => {
  return (
    <JwtProvider>
      <UserProvider>
        <TabIndexProvider>
          <UpdateMessageProvider>
            <UpdateTimeSlotProvider>
              <UpdateAnnouncementProvider>
                {children}
              </UpdateAnnouncementProvider>
            </UpdateTimeSlotProvider>
          </UpdateMessageProvider>
        </TabIndexProvider>
      </UserProvider>
    </JwtProvider>
  );
};

export default ContextProvider;
